import { PERCENTAGE_FROM_FRACTION_SUB_TYPE } from "../types/constants";
import { useMemo } from "react";
import { useGetAvailableAggregatorsQuery } from "services/reportsV3Service";

export function getAggregationOptionsFromData(groupFuncs, type) {
  return groupFuncs
    .filter((f) => f.validFor.length === 0 || f.validFor.includes(type))
    .map((f) => ({ value: f.func, label: f.displayName }));
}

export function getFunctionLabelFromData(groupFuncs, func) {
  return groupFuncs.find((f) => f.func === func)?.displayName ?? func;
}

export function useGroupAggregators() {
  const { data } = useGetAvailableAggregatorsQuery();
  return useMemo(() => {
    const groupFuncs = data?.GROUP ?? [];
    return {
      getAggregationOptions: (type) =>
        getAggregationOptionsFromData(groupFuncs, type),
      getFunctionLabel: (func) => getFunctionLabelFromData(groupFuncs, func),
    };
  }, [data]);
}

export function getDefaultAggregation(type, subType) {
  if (type === "INT" || type === "FLOAT") {
    if (
      subType === "PERCENTAGE" ||
      subType === "TARGET_PERCENTAGE" ||
      subType === "RATIO" ||
      subType === "PER_MILLION" ||
      subType === PERCENTAGE_FROM_FRACTION_SUB_TYPE
    ) {
      return "AVERAGE";
    }
    if (subType === "YEAR") return "MIN";
    return "SUM";
  }
  if (type === "BOOL") return "MAJORITY";
  if (type === "DATE") return "MIN";
  return "CONCAT";
}
